package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class CreatePaymentIntentRequest(
    val eventId: String,
    val quantity: Int? = null,
    val ticketIds: List<String>? = null,
    val priceTierName: String? = null,
    val overrideAmount: Double? = null,
    val currency: String? = null,
    val bookingId: Long? = null,
    @Serializable(with = InstantIso8601Serializer::class)
    val occurrenceDateTime: Instant? = null,
    val successUrl: String? = null,
    val cancelUrl: String? = null,
)

@Serializable
data class CreatePaymentIntentResponse(
    val clientSecret: String,
    val paymentIntentId: String,
    val publishableKey: String,
    val checkoutUrl: String? = null,
    val paymentId: String? = null,
)
